import React, { useEffect, useState } from 'react';
import './AccessibilityWidget.css';

const defaultSettings = {
  highContrast: false,
  invert: false,
  grayscale: false,
  largeText: false,
  dyslexia: false,
  reduceMotion: false,
  calmMode: false,
};

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
];

function AccessibilityWidget() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(defaultSettings);
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const body = document.body;
    Object.entries(settings).forEach(([key, value]) => {
      const className = `acc-${key}`;
      if (value) {
        body.classList.add(className);
      } else {
        body.classList.remove(className);
      }
    });
  }, [settings]);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const toggleSetting = (key) => {
    setSettings((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className={`acc-widget ${open ? 'open' : ''}`}>
      <button className="acc-toggle icon-btn" onClick={() => setOpen(!open)}>
        ♿
      </button>

      {open && (
        <div className="acc-panel">
          <div className="acc-panel-header">
            <div>
              <p className="acc-title">Accessibility</p>
              <p className="acc-subtitle">Adjust view and preferences</p>
            </div>
            <button className="acc-close" onClick={() => setOpen(false)}>
              ×
            </button>
          </div>

          <div className="acc-section">
            <label className="acc-label" htmlFor="lang-select">
              Language
            </label>
            <select
              id="lang-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              {languages.map((lang) => (
                <option key={lang.code} value={lang.code}>
                  {lang.label}
                </option>
              ))}
            </select>
          </div>

          <div className="acc-section">
            <p className="acc-label">Visual</p>
            <div className="acc-controls">
              <button
                className={`acc-chip ${settings.highContrast ? 'active' : ''}`}
                onClick={() => toggleSetting('highContrast')}
              >
                High Contrast
              </button>
              <button
                className={`acc-chip ${settings.invert ? 'active' : ''}`}
                onClick={() => toggleSetting('invert')}
              >
                Invert Colors
              </button>
              <button
                className={`acc-chip ${settings.grayscale ? 'active' : ''}`}
                onClick={() => toggleSetting('grayscale')}
              >
                Grayscale
              </button>
              <button
                className={`acc-chip ${settings.largeText ? 'active' : ''}`}
                onClick={() => toggleSetting('largeText')}
              >
                Larger Text
              </button>
            </div>
          </div>

          <div className="acc-section">
            <p className="acc-label">Focus &amp; Comfort</p>
            <div className="acc-controls">
              <button
                className={`acc-chip ${settings.dyslexia ? 'active' : ''}`}
                onClick={() => toggleSetting('dyslexia')}
              >
                Dyslexia-Friendly Font
              </button>
              <button
                className={`acc-chip ${settings.reduceMotion ? 'active' : ''}`}
                onClick={() => toggleSetting('reduceMotion')}
              >
                Reduce Motion
              </button>
              <button
                className={`acc-chip ${settings.calmMode ? 'active' : ''}`}
                onClick={() => toggleSetting('calmMode')}
              >
                ADHD-Friendly Calm Mode
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccessibilityWidget;
